module.exports = {
	baseURL: 'https://dochq.co.uk/',
	baseAPI: 'https://dochq.co.uk/api/',
	discountAPI: 'https://services-discounts.dochq.co.uk/',
	covid19API: 'https://services-covid-19.dochq.co.uk/',
	contactAPI: 'https://dochq-contact-api.dochq.co.uk',
	brochureAPI: 'https://hooks.zapier.com/hooks/catch/4296899/orfbark/',
	featureFlags: {},
};
